import {writable} from 'svelte/store';
import Helper from '../Models/Helper';
import Pattern from '../Models/Pattern';

const content = {version: {}, cache: {}, queue: [], requesting: {}, batch_count: 0, batch_timeout: 0, batch_loaded: false};
const data = writable(content);

function setBatchBusy() {
	content.batch_count++;
	clearTimeout(content.batch_timeout);
	content.batch_loaded = false;
	data.set(content);
}

function setBatchLoad() {
	content.batch_count--;
	if (content.batch_count === 0) {
		const proceed = () => {
			content.batch_loaded = true;
			data.set(content);
		};

		content.batch_timeout = setTimeout(proceed, 250);
		data.set(content);
	}

	data.set(content);
}

function setCache(uri, response) {
	content.cache[uri] = response;
	if (content.requesting[uri]) {
		for (const item of content.requesting[uri])
			item.resolve(response);

		delete content.requesting[uri];
	}

	data.set(content);
}

function requestJSON(uri) {
	setBatchBusy();
	const url = `./data/json/${uri}.json`;
	fetch(url).then(response => response.json()).then(content => {
		setBatchLoad();
		setCache(uri, content);
	});
}

function requestJSONP(resolve, reject, uri) {
	const next = request => {
		JSONP.busy = true;
		const url = `./data/jsonp/${request.uri}.js`;
		const script = document.createElement('script');
		script.type = 'text/javascript';
		script.crossOrigin = 'anonymous';
		script.src = url;

		JSONP.onSet(source => {
			jQuery(script).remove();
			setBatchLoad();
			JSONP.busy = false;
			setCache(uri, source);
			request.resolve(source);
			if (content.queue.length) {
				const item = content.queue.shift();
				data.set(content);
				next(item);
			}
		});

		jQuery('body').append(script);
	};

	setBatchBusy();
	content.queue.push({uri, resolve, reject});
	data.set(content);

	if (!JSONP.busy) {
		const item = content.queue.shift();
		data.set(content);
		next(item);
	}
}

/* Public */

data.init = async () => {
	await data.version();
};

data.version = async () => {
	let item = {};
	const versions = await data.absolute('versions');

	if (Helper.app()) {
		const html = window.document.querySelector('html');
		const code = html.getAttribute('data-version') || 'BB';
		for (const version of versions)
			if (version.code === code) {
				item = version;
				break;
			}
	}

	else {
		const host = window.location.hostname;
		for (const version of versions)
			if (version.hosts.includes(host)) {
				item = version;
				break;
			}
	}

	content.version = item;
	data.set(content);
};

data.absolute = uri => {
	return new Promise((resolve, reject) => {
		if (Helper.undefined(content.cache[uri])) {
			if (!Helper.app()) {
				const requesting = !!content.requesting[uri];
				if (!requesting) content.requesting[uri] = [];
				content.requesting[uri].push({resolve, reject});
				if (!requesting) requestJSON(uri);
			}
			else requestJSONP(resolve, reject, uri);
		}
		else resolve(content.cache[uri]);
	});
};

data.relative = uri => {
	const url = `${content.version.code}/${uri}`;
	return data.absolute(url);
};

export default data;